<template>
  <div>

    <div class="form">
      <validation-observer
          v-slot="{ handleSubmit }"
          ref="refFormObserver"
      >
        <b-form
            ref="form"
            @submit.stop.prevent="handleSubmit(createNewGroup($event))"
            class="form validate"
        >
          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="student"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Выберите учеников')"
                  label-for="student"
              >
                <v-select
                    multiple
                    name="student"
                    :options="students"
                    label="name"
                    v-model="form.students"
                    :reduce="model => model.id"
                >
                </v-select>
              </b-form-group>
            </validation-provider>
          </div>

          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="teacher"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Выберите учителя')"
                  label-for="teacher"
              >
                <v-select
                    name="teacher_id"
                    :options="teachers"
                    label="name"
                    v-model="form.teacher"
                    :reduce="model => model.id"
                >
                </v-select>
              </b-form-group>
            </validation-provider>
          </div>

          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="program"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Выберите программу')"
                  label-for="program"
              >
                <v-select
                    name="program_id"
                    :options="programs"
                    label="name"
                    v-model="form.program"
                    :reduce="model => model.id"
                >
                </v-select>
              </b-form-group>
            </validation-provider>
          </div>

          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="date"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Название')"
                  label-for="date"
              >
                <b-form-input
                    type="text"
                    trim
                    v-model="form.name"
                />
              </b-form-group>
            </validation-provider>
          </div>

          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="date"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Описание')"
                  label-for="date"
              >
                <b-form-input
                    type="text"
                    trim
                    v-model="form.description"
                />
              </b-form-group>
            </validation-provider>
          </div>
          <b-button v-if="!form.id" type="submit" variant="primary"> {{ $t('Создать группу') }}</b-button>
          <template v-else >
            <b-button type="submit" variant="primary"> {{ $t('Редактировать группу') }}</b-button>
            <b-button class="ml-2" @click="removeEditing" type="reset" variant="warning"> {{$t('Закрыть редактирование') }}
            </b-button>
          </template>
        </b-form>
      </validation-observer>
    </div>
    <!-- input search -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
        :columns="columns"
        :rows="groups"
        :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
        :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
          slot="table-row"
          slot-scope="props"
      >

        <!-- Column: Name -->
        <div
            v-if="props.column.field === 'user_id'"
            class="text-nowrap"
        >
          <span class="text-nowrap">{{ getModelName('teachers', props.row.user_id, 'name') }}</span>
        </div>

        <div
            v-else-if="props.column.field === 'students'"
            class="text-nowrap"
        >
          <span v-for="user in props.row.users" class="text-nowrap">
            {{ getModelName('students', user.id, 'name') }}
          </span>
        </div>

        <div
            v-else-if="props.column.field === 'program_id'"
            class="text-nowrap"
        >
          <span class="text-nowrap">{{ getModelName('programs', props.row.program_id, 'name') }}</span>
        </div>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="editGroup(props.row.id)">
                <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteGroup(props.row.id)">
                <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
          slot="pagination-bottom"
          slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
                v-model="pageLength"
                :options="['3','5','10']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap "> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>

import {
  BAvatar,
  BBadge,
  BButton,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BPagination
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {createNamespacedHelpers} from 'vuex';
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import formattedDate from '@/mixins/formattedDate'
import CRMApi from '@/api/crm'

const {mapState, mapActions, mapMutations} = createNamespacedHelpers('crm')

export default {
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormInvalidFeedback,
    BForm,
    BButton,
    ValidationObserver,
    ValidationProvider,
    vSelect,
    flatPickr
  },
  mixins: [formattedDate],
  data() {
    return {
      pageLength: 3,
      dir: false,
      columns: [
        {
          label: 'Название',
          field: 'name',
        },
        {
          label: 'Описание',
          field: 'description',
        },
        {
          label: 'Ученики',
          field: 'students',
        },
        {
          label: 'Учитель',
          field: 'user_id',
        },
        {
          label: 'Программа',
          field: 'program_id',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
      form: {
        students: [],
        teacher: '',
        name: '',
        description: '',
        program: '',
      },
      activeTrial: {},
      programs: [],
    }
  },
  computed: {
    ...mapState({
      teachers: state => state.teachers,
      students: state => state.students,
      groups: state => state.groups
    })
  },
  methods: {
    ...mapActions(['getGroups', 'createGroup', 'getUsers']),
    createNewGroup() {
      let groupData = {
        students: this.form.students,
        user_id: this.form.teacher,
        description: this.form.description,
        name: this.form.name,
        program_id: this.form.program,
      }
      let message = {
        title: 'Группа была создана',
        message: 'Группа создана'
      }
      if (this.form.id) {
        groupData.id = this.form.id;
        message = {
          title: 'Группа была отредактирована',
          message: 'Вы успешно отредактировали группу'
        }
      }
      this.createGroup(groupData)
          .then(() => {
            this.form = {
              students: [],
              teacher: '',
              name: '',
              description: '',
              program: '',
            }
            this.$bvToast.toast(this.$t(message.title), {
              title: this.$t(message.message),
              variant: 'success',
              solid: true,
            })
          })
          .catch(err => {
            this.$bvToast.toast(this.$t('Ошибка сервера, попробуйте позже'), {
              title: this.$t('Ошибка сервера, обратитесь к разработчику'),
              variant: 'danger',
              solid: true,
            })
          })

    },
    closeEditing() {
      this.activeTrial = {}
    },
    getPrograms() {
      CRMApi.getPrograms()
          .then(res => {
            this.programs = res.data
          })
    },
    deleteGroup(id) {
      this.$bvModal
          .msgBoxConfirm('Пожалуйста, подтвердите, что вы хотите удалить группу', {
            title: 'Подтверждение',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Да',
            cancelTitle: 'Нет',
            cancelVariant: 'primary',
            hideHeaderClose: false,
            centered: true,
          })
          .then(res => {
            if (res) {
              CRMApi.deleteGroup(id)
                  .then(res => {
                    this.$bvToast.toast(this.$t('Группа успешно удалена'), {
                      title: this.$t('Группа удалена'),
                      variant: 'success',
                      solid: true,
                    })
                    this.getGroups();
                  })
                  .catch(err => {
                    this.$bvToast.toast(this.$t('Ошибка сервера, попробуйте позже'), {
                      title: this.$t('Ошибка сервера, обратитесь к разработчику'),
                      variant: 'danger',
                      solid: true,
                    })
                  })
            }
          })

    },
    editGroup(id) {
      let activeGroup = this.groups.find(group => group.id === id)
      this.form.students = activeGroup.users.map(student => student.id)
      this.form.teacher = activeGroup.user_id;
      this.form.name = activeGroup.name
      this.form.description = activeGroup.description
      this.form.program = activeGroup.program_id
      this.form.id = activeGroup.id;
    },
    removeEditing() {
      this.form = {
        students: [],
        teacher: '',
        name: '',
        description: '',
        program: '',
      }
    }
  },
  created() {
    this.getGroups();
    this.getUsers();
    this.getPrograms();
  }
}
</script>

<style scoped>

</style>
